import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Controller, useFormContext } from 'react-hook-form';
import { StretchedDropzonePlaceholder } from '../DropzonePlaceholder/DropzonePlaceholder';
import { Form as FormModule, Utils } from 'billon-ui';

const { UploadField } = FormModule;
const { Button: ButtonModule } = Utils;
const { Button } = ButtonModule;

export const ControlledUploadField = ({
  name = 'file',
  disabled,
  maxSize = 5000,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { formatMessage } = useIntl();

  const limitInMB = (maxSize / 1000).toFixed(2);

  const maxSizeDescription = formatMessage({
    id: 'Drag and drop here PDF max 2MB',
  }).replace('2', limitInMB);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <UploadField
          input={field}
          meta={{
            touched: fieldState.invalid,
            error: errors?.[field.name]?.message,
          }}
          disabled={disabled}
          placeholder={() => (
            <StretchedDropzonePlaceholder>
              <div>{maxSizeDescription}</div>
              <div>
                <FormattedMessage id="or" defaultMessage="or" />
              </div>
              <Button outline type="button">
                <FormattedMessage
                  id="Select from disk"
                  defaultMessage="Select from disk"
                />
              </Button>
            </StretchedDropzonePlaceholder>
          )}
        />
      )}
    />
  );
};
